var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('h1',[_vm._v(_vm._s(_vm.msg))]),_vm._v(" "),_c('button-red',{on:{"click":_vm.countUp}},[_vm._v("Vue Component")]),_vm._v(" "),_c('wc-button-red',{on:{"click":_vm.countUp}},[_vm._v("Web Components")]),_vm._v(" "),_c('div',{staticClass:"count"},[_vm._v("count:"+_vm._s(_vm.count))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cfc5957a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 19
// module chunks = 0